import Employee from '../dto/Employee';
import EmployeeKnowledge from '../dto/EmployeeKnowledge';
import Error from '../model/Error';
import SpokenLanguage from '../dto/SpokenLanguage';
import axios from 'axios';

export default class EmployeeRepository {

    static getKnowledgeData(employeeId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/employees/${employeeId}/knowledge`)
                .then(response => resolve(EmployeeKnowledge.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateKnowledge(employeeId, employeeKnowledge) {

        return new Promise((resolve, reject) => {
            axios
                .put(`/employees/${employeeId}/knowledge`, employeeKnowledge.serialize())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findSpokenLanguages(employeeId)
    {
        return new Promise((resolve, reject) => {
            axios
                .get(`/employees/${employeeId}/spoken-languages`)
                .then(response => resolve(response.data.data.map(data => SpokenLanguage.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeSpokenLanguage(employeeId, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/employees/${employeeId}/spoken-languages/${id}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateSpokenLanguage(employeeId, spokenLanguage) {
        const data = {
            id: spokenLanguage.id,
            languageCode: spokenLanguage.language.code,
            level: spokenLanguage.level,
            invalid: spokenLanguage.invalid,
        };

        return new Promise((resolve, reject) => {
            axios
                .put(`/employees/${employeeId}/spoken-languages/${spokenLanguage.id}`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createSpokenLanguage(employeeId, spokenLanguage) {
        const data = {
            languageCode: spokenLanguage.language.code,
            level: spokenLanguage.level,
            invalid: spokenLanguage.invalid,
        };

        return new Promise((resolve, reject) => {
            axios
                .post(`/employees/${employeeId}/spoken-languages`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/kindergartens/' + kindergartenId + '/employees')
                .then(response => resolve(response.data.data.map(data => Employee.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
